import { Route, Routes } from 'react-router-dom';
import { ROLE } from '../../../Constant';
import { PrivateRoute } from '../../components/PrivateRoute';
import User from './nguoi-su-dung';

import GroupPermission from './nhom-quyen';

export default function NguoiDung() {

  return (
    <Routes>
      {/* <Route path="nhom-quyen/*" element={<GroupPermission/></PrivateRoute> }/> */}
      <Route path="nhom-quyen/*" element={<GroupPermission />} />


      {/* <Route path="nguoi-su-dung/*" element={<PrivateRoute role={ROLE.USER_MANAGEMENT_USERS}> <User/></PrivateRoute>}/> */}
      <Route path="nguoi-su-dung/*" element={<User />} />
    </Routes>
  );
}
